import { useState } from "react";
import { api, ApiError } from "../api";

/** Port of engine/index-login.php, keeping the same markup so the CSS applies. */
export default function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (busy) return;
    setError("");
    if (!login.trim() || !pass) {
      setError("Введите логин и пароль");
      return;
    }
    setBusy(true);
    try {
      await api.login(login.trim(), pass);
      onLoggedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось войти");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container-center">
      <div className="login">
        <div className="login-error" style={{ display: error ? "block" : undefined }}>
          {error}
        </div>
        <div className="login-header">Вход в систему</div>
        <div className="login-field">
          <div style={{ backgroundImage: "url(/svg/login_login.svg)" }} />
          <input
            type="text"
            name="login"
            placeholder="Логин"
            value={login}
            autoComplete="username"
            onChange={(e) => setLogin(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
          />
        </div>
        <div className="login-field">
          <div style={{ backgroundImage: "url(/svg/login_pass.svg)" }} />
          <input
            type="password"
            name="pass"
            placeholder="Пароль"
            value={pass}
            autoComplete="current-password"
            onChange={(e) => setPass(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
          />
        </div>
        <div className="button login-button" onClick={submit}>
          {busy ? "…" : "Войти"}
        </div>
      </div>
    </div>
  );
}
